module.exports = __webpack_public_path__ + "static/media/17.f75d8010.jpg";